
import React, { Component } from 'react';
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import { BASE } from '../api/api'
import Axios from 'axios'
import './login.css'
import load from '../assets/loading.gif'

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            pwd: '',
            email: '',
            cpwd: '',
            phone: '',
            login_state: true,
            load: false
        }
    }

    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    componentWillMount() {
        this.topFunction()
    }

    fillalert(msg) {
        this.topFunction()
        this.setState({
            filltext: msg,
            fillalert: true
        })
        setTimeout(
            function () {
                this.setState({
                    fillalert: null
                })
            }
                .bind(this),
            3000
        );
    }
    showalert() {
        this.topFunction()
        this.setState({
            pwdalert: true,
            namealert: true,
            cpwdalert: true,
            emailalert: true,
            phonealert: true
        })
    }

    submit() {
        if (this.state.login_state == true && this.state.name.length > 0 && this.state.pwd.length > 0) {

            this.login(this.state.name, this.state.pwd)
        }
        else if (this.state.login_state == true) {
            this.topFunction()
            this.setState({
                pwdalert: true,
                namealert: true
            })
        }
        else if (this.state.login_state == false) {
            if (this.state.name.length > 2) {
                if (this.state.pwd === this.state.cpwd) {
                    let term = this.state.phone.replace(/\s/g, '');
                    let re = new RegExp(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+$/g);
                    let ere = new RegExp("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}")
                    if (this.state.email) {
                        if (ere.test(this.state.email) == true) {
                            this.setState({
                                load: true
                            })
                            let formbody = {
                                "name": [{ "value": this.state.name }],
                                "mail": [{ "value": this.state.email }],
                                "pass": [{ "value": this.state.pwd }],
                                "field_first_name": [{ "value": this.state.fname }],
                                "field_last_name": [{ "value": this.state.lname }],
                                "field_phone_number": [{ "value": this.state.phone }],
                                "field_city": [{ "value": this.state.city ? this.state.city : null }],
                                "field_country": [{ "value": this.state.country ? this.state.country : null }],
                                "field_occupation": [{ "value": this.state.occupation ? this.state.occupation : null }],
                                "field_organisation": [{ "value": this.state.organisation ? this.state.organisation : null }]
                            }
                            Axios({
                                url: BASE + "user/register?_format=json",
                                method: "POST",
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                data: formbody
                            })
                                .then((data) => {
                                    localStorage.setItem('username', this.state.name)
                                    localStorage.setItem('userpass', this.state.pwd)
                                    this.props.history.push("/verify")
                                    this.setState({
                                        load: false
                                    })
                                })
                                .catch((err) => {
                                    this.setState({
                                        load: false
                                    })
                                    console.log(err.response.data, "high22")
                                    let error = err.response.data.message;
                                    // let ind = error.indexOf("failed");
                                    // if (ind > 0) {
                                    //     this.fillalert(error.substring(ind + 7))
                                    // }
                                    // else
                                    this.fillalert(error)
                                });
                        }
                        else {
                            this.fillalert("Enter a valid email id")
                        }
                    }
                    else {
                        this.showalert()
                    }
                }
                else {
                    this.fillalert("Passwords do not match")
                }
            }
            else {
                this.showalert()
                if (this.state.name.length !== 0)
                    this.fillalert("Username must be minimum 3 charecters long")
            }

        }
    }
    login(name, pwd) {
        this.setState({
            load: true
        })
        if (this.authorcheck()) {
            let details = {
                grant_type: "password",
                client_id: "ab15755c-47f7-4699-b306-75f6a58c00b7",
                client_secret: "default",
                username: name,
                password: pwd
            }
            let url = window.location.href;
            let url_string = url;
            let urlStr = new URL(url_string);
            let redir = urlStr.searchParams.get("redir");
            let formBody = [];
            for (let property in details) {
                let encodedKey = encodeURIComponent(property);
                let encodedValue = encodeURIComponent(details[property]);
                formBody.push(encodedKey + "=" + encodedValue);
            }
            formBody = formBody.join("&");
            Axios({
                url: BASE + "oauth/token",
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: formBody
            })
                .then((data) => {
                    if (data.data.access_token) {
                        Axios({
                            url: BASE + "jsonapi/user/user/?filter[name][condition][path]=name&filter[name][condition][value]=" + name,
                            method: "GET",
                            headers: {
                                'Authorization': "Bearer " + data.data.access_token
                            },
                        })
                            .then((da) => {
                                this.setState({
                                    load: false
                                })
                                if (da.data.data.length > 0) {
                                    console.log(data.data, "expi")
                                    localStorage.setItem('token', data.data.access_token)
                                    localStorage.setItem("uid", da.data.data[0].id)
                                    let s = new Date();
                                    s.setSeconds(s.getSeconds() + data.data.expires_in);
                                    s.setMinutes(s.getMinutes() + 2000);
                                    console.log('gettime', s)
                                    localStorage.setItem('expiryref', s)
                                    localStorage.setItem('expirytime', s);
                                    if (redir) {
                                        this.props.history.push(redir)
                                    }
                                    else
                                        this.props.history.push('/')
                                }
                                else
                                    this.fillalert("Something went wrong, Please try again")
                            })
                    }

                })
                .catch((err) => {
                    this.setState({
                        load: false
                    })
                    this.fillalert("Username and password do not match")
                })
        }
    }

    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.submit()
        }
    }

    authorcheck() {
        if (this.state.pwd && this.state.name)
            return true
        else {
            this.setState({
                pwd: this.state.pwd ? null : true,
                name: this.state.name ? null : true,
                load: false
            })
            return false
        }
    }

    handleChangeSelect = (e) => {

        this.setState({
            [e.target.name]: e.target.value,
        })
    }

    clearalerts() {

    }

    componentDidUpdate() {

    }
    render() {

        if (localStorage.getItem('token') && localStorage.getItem('token') != null) {
            this.props.history.goBack()
        }

        return (
            <div className={this.state.login_state == true ? 'signuppage' : 'signuppage'}>
                {this.state.load ? <div className='loading'>
                    <img src={load} alt='load' />
                </div> : ''}
                {this.state.fillalert ? <div className="fill-alert">{this.state.filltext}</div> : ''}
                <Header />
                <div className="listing" style={{ minHeight: '65vh' }}>
                    <div className="page-title">
                        <div className="title-wrapper">
                            <div className="container">
                                <h1 className="sign-heading">{this.state.login_state == true ? "Login" : "Create an Account"}</h1>
                            </div>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="container">
                            <div className="row">
                                <div className="region region-content">
                                    <form className="webform-client-form webform-client-form-275" id="webform-client-form-275" accept-charset="UTF-8">
                                        <div>
                                            <div className="form-component" style={{ display: this.state.login_state == false ? '' : 'none' }}>
                                                <input id="fname" placeholder="First Name*" name="fname" type="text" value={this.state.fname}
                                                    onChange={(e) => this.setState({ fname: e.target.value })} />
                                                {this.state.fnamealert && !this.state.fname ? <div class="alert-tag">The <strong>Email</strong> cannot be empty</div> : null}
                                            </div>
                                            <div className="form-component" style={{ display: this.state.login_state == false ? '' : 'none' }}>
                                                <input id="lname" placeholder="Last Name*" name="lname" type="text" value={this.state.lname}
                                                    onChange={(e) => this.setState({ lname: e.target.value })} />
                                                {this.state.lnamealert && !this.state.lname ? <div class="alert-tag">The <strong>Email</strong> cannot be empty</div> : null}
                                            </div>
                                            <div className="form-component" >
                                                <label for="edit-submitted-name">Username <span className="form-required" title="This field is required.">*</span></label>
                                                <input id="name" name="name" placeholder="Username*" type="text" value={this.state.name}
                                                    onChange={(e) => this.setState({ name: e.target.value })} />
                                                {this.state.namealert && !this.state.name ?
                                                    <div class="alert-tag">The <strong>Username</strong> cannot be empty</div> : null}
                                            </div>
                                            <div className="form-component" style={{ display: this.state.login_state == false ? '' : 'none' }}>
                                                <label for="edit-submitted-email">Email <span className="form-required" title="This field is required.">*</span></label>
                                                <input id="email" placeholder="Email*" name="email" type="text" value={this.state.email}
                                                    onChange={(e) => this.setState({ email: e.target.value })} />
                                                {this.state.emailalert && !this.state.email ? <div class="alert-tag">The <strong>Email</strong> cannot be empty</div> : null}
                                            </div>
                                            {/* <div className="form-component" style={{ display: this.state.login_state == false ? '' : 'none' }}>
                                                <label for="edit-submitted-phone">Phone Number <span className="form-required" title="This field is required.">*</span></label>
                                                <input id="phone" name="phone" type="text" value={this.state.phone}
                                                    onChange={(e) => this.setState({ phone: e.target.value })} />
                                                {this.state.phonealert && !this.state.phone ? <div class="alert-tag">The <strong>Phone Number</strong> cannot be empty</div> : null}
                                            </div> */}
                                            <div className="form-component" >
                                                <label for="edit-submitted-pwd">Password <span className="form-required" title="This field is required.">*</span></label>
                                                <input id="pwd" name="pwd" placeholder="Password*" type="password" value={this.state.pwd}
                                                    onKeyPress={(e) => this._handleKeyPress(e)} onChange={(e) => this.setState({ pwd: e.target.value })} />
                                                {this.state.pwdalert && !this.state.pwd ? <div class="alert-tag">The <strong>Password</strong> cannot be empty</div> : null}

                                            </div>
                                            <div className="form-component" style={{ display: this.state.login_state == false ? '' : 'none' }}>
                                                <label for="edit-submitted-cpwd"> Confirm Password <span className="form-required" title="This field is required.">*</span></label>
                                                <input id="cpwd" name="cpwd" type="password" placeholder="Reconfirm Password*" autocomplete="nofill" value={this.state.cpwd}
                                                    onChange={(e) => this.setState({ cpwd: e.target.value })} />
                                                {this.state.cpwdalert && !this.state.cpwd ? <div class="alert-tag">The <strong>Confirm Password</strong> cannot be empty</div> : null}
                                            </div>
                                            {/* <div className="form-component" style={{ display: this.state.login_state == false ? '' : 'none' }} >
                                                <label for="edit-submitted-name">Country </label>
                                                <select name="country" onChange={e => this.handleChangeSelect(e)} value={this.state.country}>
                                                    <option value="" disabled selected>Select</option>

                                                    <option value="AF">Afghanistan</option>
                                                    <option value="AX">Åland Islands</option>
                                                    <option value="AL">Albania</option>
                                                    <option value="DZ">Algeria</option>
                                                    <option value="AS">American Samoa</option>
                                                    <option value="AD">Andorra</option>
                                                    <option value="AO">Angola</option>
                                                    <option value="AI">Anguilla</option>
                                                    <option value="AQ">Antarctica</option>
                                                    <option value="AG">Antigua and Barbuda</option>
                                                    <option value="AR">Argentina</option>
                                                    <option value="AM">Armenia</option>
                                                    <option value="AW">Aruba</option>
                                                    <option value="AU">Australia</option>
                                                    <option value="AT">Austria</option>
                                                    <option value="AZ">Azerbaijan</option>
                                                    <option value="BS">Bahamas</option>
                                                    <option value="BH">Bahrain</option>
                                                    <option value="BD">Bangladesh</option>
                                                    <option value="BB">Barbados</option>
                                                    <option value="BY">Belarus</option>
                                                    <option value="BE">Belgium</option>
                                                    <option value="BZ">Belize</option>
                                                    <option value="BJ">Benin</option>
                                                    <option value="BM">Bermuda</option>
                                                    <option value="BT">Bhutan</option>
                                                    <option value="BO">Bolivia, Plurinational State of</option>
                                                    <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                                                    <option value="BA">Bosnia and Herzegovina</option>
                                                    <option value="BW">Botswana</option>
                                                    <option value="BV">Bouvet Island</option>
                                                    <option value="BR">Brazil</option>
                                                    <option value="IO">British Indian Ocean Territory</option>
                                                    <option value="BN">Brunei Darussalam</option>
                                                    <option value="BG">Bulgaria</option>
                                                    <option value="BF">Burkina Faso</option>
                                                    <option value="BI">Burundi</option>
                                                    <option value="KH">Cambodia</option>
                                                    <option value="CM">Cameroon</option>
                                                    <option value="CA">Canada</option>
                                                    <option value="CV">Cape Verde</option>
                                                    <option value="KY">Cayman Islands</option>
                                                    <option value="CF">Central African Republic</option>
                                                    <option value="TD">Chad</option>
                                                    <option value="CL">Chile</option>
                                                    <option value="CN">China</option>
                                                    <option value="CX">Christmas Island</option>
                                                    <option value="CC">Cocos (Keeling) Islands</option>
                                                    <option value="CO">Colombia</option>
                                                    <option value="KM">Comoros</option>
                                                    <option value="CG">Congo</option>
                                                    <option value="CD">Congo, the Democratic Republic of the</option>
                                                    <option value="CK">Cook Islands</option>
                                                    <option value="CR">Costa Rica</option>
                                                    <option value="CI">Côte d'Ivoire</option>
                                                    <option value="HR">Croatia</option>
                                                    <option value="CU">Cuba</option>
                                                    <option value="CW">Curaçao</option>
                                                    <option value="CY">Cyprus</option>
                                                    <option value="CZ">Czech Republic</option>
                                                    <option value="DK">Denmark</option>
                                                    <option value="DJ">Djibouti</option>
                                                    <option value="DM">Dominica</option>
                                                    <option value="DO">Dominican Republic</option>
                                                    <option value="EC">Ecuador</option>
                                                    <option value="EG">Egypt</option>
                                                    <option value="SV">El Salvador</option>
                                                    <option value="GQ">Equatorial Guinea</option>
                                                    <option value="ER">Eritrea</option>
                                                    <option value="EE">Estonia</option>
                                                    <option value="ET">Ethiopia</option>
                                                    <option value="FK">Falkland Islands (Malvinas)</option>
                                                    <option value="FO">Faroe Islands</option>
                                                    <option value="FJ">Fiji</option>
                                                    <option value="FI">Finland</option>
                                                    <option value="FR">France</option>
                                                    <option value="GF">French Guiana</option>
                                                    <option value="PF">French Polynesia</option>
                                                    <option value="TF">French Southern Territories</option>
                                                    <option value="GA">Gabon</option>
                                                    <option value="GM">Gambia</option>
                                                    <option value="GE">Georgia</option>
                                                    <option value="DE">Germany</option>
                                                    <option value="GH">Ghana</option>
                                                    <option value="GI">Gibraltar</option>
                                                    <option value="GR">Greece</option>
                                                    <option value="GL">Greenland</option>
                                                    <option value="GD">Grenada</option>
                                                    <option value="GP">Guadeloupe</option>
                                                    <option value="GU">Guam</option>
                                                    <option value="GT">Guatemala</option>
                                                    <option value="GG">Guernsey</option>
                                                    <option value="GN">Guinea</option>
                                                    <option value="GW">Guinea-Bissau</option>
                                                    <option value="GY">Guyana</option>
                                                    <option value="HT">Haiti</option>
                                                    <option value="HM">Heard Island and McDonald Islands</option>
                                                    <option value="VA">Holy See (Vatican City State)</option>
                                                    <option value="HN">Honduras</option>
                                                    <option value="HK">Hong Kong</option>
                                                    <option value="HU">Hungary</option>
                                                    <option value="IS">Iceland</option>
                                                    <option value="IN">India</option>
                                                    <option value="ID">Indonesia</option>
                                                    <option value="IR">Iran, Islamic Republic of</option>
                                                    <option value="IQ">Iraq</option>
                                                    <option value="IE">Ireland</option>
                                                    <option value="IM">Isle of Man</option>
                                                    <option value="IL">Israel</option>
                                                    <option value="IT">Italy</option>
                                                    <option value="JM">Jamaica</option>
                                                    <option value="JP">Japan</option>
                                                    <option value="JE">Jersey</option>
                                                    <option value="JO">Jordan</option>
                                                    <option value="KZ">Kazakhstan</option>
                                                    <option value="KE">Kenya</option>
                                                    <option value="KI">Kiribati</option>
                                                    <option value="KP">Korea, Democratic People's Republic of</option>
                                                    <option value="KR">Korea, Republic of</option>
                                                    <option value="KW">Kuwait</option>
                                                    <option value="KG">Kyrgyzstan</option>
                                                    <option value="LA">Lao People's Democratic Republic</option>
                                                    <option value="LV">Latvia</option>
                                                    <option value="LB">Lebanon</option>
                                                    <option value="LS">Lesotho</option>
                                                    <option value="LR">Liberia</option>
                                                    <option value="LY">Libya</option>
                                                    <option value="LI">Liechtenstein</option>
                                                    <option value="LT">Lithuania</option>
                                                    <option value="LU">Luxembourg</option>
                                                    <option value="MO">Macao</option>
                                                    <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                                                    <option value="MG">Madagascar</option>
                                                    <option value="MW">Malawi</option>
                                                    <option value="MY">Malaysia</option>
                                                    <option value="MV">Maldives</option>
                                                    <option value="ML">Mali</option>
                                                    <option value="MT">Malta</option>
                                                    <option value="MH">Marshall Islands</option>
                                                    <option value="MQ">Martinique</option>
                                                    <option value="MR">Mauritania</option>
                                                    <option value="MU">Mauritius</option>
                                                    <option value="YT">Mayotte</option>
                                                    <option value="MX">Mexico</option>
                                                    <option value="FM">Micronesia, Federated States of</option>
                                                    <option value="MD">Moldova, Republic of</option>
                                                    <option value="MC">Monaco</option>
                                                    <option value="MN">Mongolia</option>
                                                    <option value="ME">Montenegro</option>
                                                    <option value="MS">Montserrat</option>
                                                    <option value="MA">Morocco</option>
                                                    <option value="MZ">Mozambique</option>
                                                    <option value="MM">Myanmar</option>
                                                    <option value="NA">Namibia</option>
                                                    <option value="NR">Nauru</option>
                                                    <option value="NP">Nepal</option>
                                                    <option value="NL">Netherlands</option>
                                                    <option value="NC">New Caledonia</option>
                                                    <option value="NZ">New Zealand</option>
                                                    <option value="NI">Nicaragua</option>
                                                    <option value="NE">Niger</option>
                                                    <option value="NG">Nigeria</option>
                                                    <option value="NU">Niue</option>
                                                    <option value="NF">Norfolk Island</option>
                                                    <option value="MP">Northern Mariana Islands</option>
                                                    <option value="NO">Norway</option>
                                                    <option value="OM">Oman</option>
                                                    <option value="PK">Pakistan</option>
                                                    <option value="PW">Palau</option>
                                                    <option value="PS">Palestinian Territory, Occupied</option>
                                                    <option value="PA">Panama</option>
                                                    <option value="PG">Papua New Guinea</option>
                                                    <option value="PY">Paraguay</option>
                                                    <option value="PE">Peru</option>
                                                    <option value="PH">Philippines</option>
                                                    <option value="PN">Pitcairn</option>
                                                    <option value="PL">Poland</option>
                                                    <option value="PT">Portugal</option>
                                                    <option value="PR">Puerto Rico</option>
                                                    <option value="QA">Qatar</option>
                                                    <option value="RE">Réunion</option>
                                                    <option value="RO">Romania</option>
                                                    <option value="RU">Russian Federation</option>
                                                    <option value="RW">Rwanda</option>
                                                    <option value="BL">Saint Barthélemy</option>
                                                    <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                                                    <option value="KN">Saint Kitts and Nevis</option>
                                                    <option value="LC">Saint Lucia</option>
                                                    <option value="MF">Saint Martin (French part)</option>
                                                    <option value="PM">Saint Pierre and Miquelon</option>
                                                    <option value="VC">Saint Vincent and the Grenadines</option>
                                                    <option value="WS">Samoa</option>
                                                    <option value="SM">San Marino</option>
                                                    <option value="ST">Sao Tome and Principe</option>
                                                    <option value="SA">Saudi Arabia</option>
                                                    <option value="SN">Senegal</option>
                                                    <option value="RS">Serbia</option>
                                                    <option value="SC">Seychelles</option>
                                                    <option value="SL">Sierra Leone</option>
                                                    <option value="SG">Singapore</option>
                                                    <option value="SX">Sint Maarten (Dutch part)</option>
                                                    <option value="SK">Slovakia</option>
                                                    <option value="SI">Slovenia</option>
                                                    <option value="SB">Solomon Islands</option>
                                                    <option value="SO">Somalia</option>
                                                    <option value="ZA">South Africa</option>
                                                    <option value="GS">South Georgia and the South Sandwich Islands</option>
                                                    <option value="SS">South Sudan</option>
                                                    <option value="ES">Spain</option>
                                                    <option value="LK">Sri Lanka</option>
                                                    <option value="SD">Sudan</option>
                                                    <option value="SR">Suriname</option>
                                                    <option value="SJ">Svalbard and Jan Mayen</option>
                                                    <option value="SZ">Swaziland</option>
                                                    <option value="SE">Sweden</option>
                                                    <option value="CH">Switzerland</option>
                                                    <option value="SY">Syrian Arab Republic</option>
                                                    <option value="TW">Taiwan, Province of China</option>
                                                    <option value="TJ">Tajikistan</option>
                                                    <option value="TZ">Tanzania, United Republic of</option>
                                                    <option value="TH">Thailand</option>
                                                    <option value="TL">Timor-Leste</option>
                                                    <option value="TG">Togo</option>
                                                    <option value="TK">Tokelau</option>
                                                    <option value="TO">Tonga</option>
                                                    <option value="TT">Trinidad and Tobago</option>
                                                    <option value="TN">Tunisia</option>
                                                    <option value="TR">Turkey</option>
                                                    <option value="TM">Turkmenistan</option>
                                                    <option value="TC">Turks and Caicos Islands</option>
                                                    <option value="TV">Tuvalu</option>
                                                    <option value="UG">Uganda</option>
                                                    <option value="UA">Ukraine</option>
                                                    <option value="AE">United Arab Emirates</option>
                                                    <option value="GB">United Kingdom</option>
                                                    <option value="US">United States</option>
                                                    <option value="UM">United States Minor Outlying Islands</option>
                                                    <option value="UY">Uruguay</option>
                                                    <option value="UZ">Uzbekistan</option>
                                                    <option value="VU">Vanuatu</option>
                                                    <option value="VE">Venezuela, Bolivarian Republic of</option>
                                                    <option value="VN">Viet Nam</option>
                                                    <option value="VG">Virgin Islands, British</option>
                                                    <option value="VI">Virgin Islands, U.S.</option>
                                                    <option value="WF">Wallis and Futuna</option>
                                                    <option value="EH">Western Sahara</option>
                                                    <option value="YE">Yemen</option>
                                                    <option value="ZM">Zambia</option>
                                                    <option value="ZW">Zimbabwe</option>
                                                </select>

                                            </div> */}
                                            {/* <div className="form-component" style={{ display: this.state.login_state == false ? '' : 'none' }}>
                                                <label for="edit-submitted-name">City </label>
                                                <input id="name" name="city" type="text" value={this.state.city}
                                                    onChange={(e) => this.setState({ city: e.target.value })} />
                                            </div>
                                            <div className="form-component" style={{ display: this.state.login_state == false ? '' : 'none' }}>
                                                <label for="edit-submitted-name">Organization </label>
                                                <input id="name" name="organisation" type="text" value={this.state.organisation}
                                                    onChange={(e) => this.setState({ organisation: e.target.value })} />
                                            </div>
                                            <div className="form-component" style={{ display: this.state.login_state == false ? '' : 'none' }}>
                                                <label for="edit-submitted-name">Occupation </label>
                                                <input id="name" name="occupation" type="text" value={this.state.occupation}
                                                    onChange={(e) => this.setState({ occupation: e.target.value })} />
                                            </div> */}
                                            <div className="cf">
                                                <div className="login_submit pointer" onClick={() => this.submit()} ><div className='button-sign'>{this.state.login_state == false ? 'Register' : 'Submit'}</div></div>
                                            </div>

                                            <div className="anchor_lnks">
                                                <a style={{ display: this.state.login_state == true ? '' : 'none' }} onClick={() => this.setState({
                                                    login_state: false, name: '',
                                                    pwd: '',
                                                    email: '',
                                                    cpwd: '',
                                                    phone: '',
                                                    namealert: '',
                                                    pwdalert: ''
                                                })}>Create a new account</a>
                                                <a style={{ display: this.state.login_state == false ? '' : 'none' }} onClick={() => this.setState({
                                                    login_state: true, name: '',
                                                    pwd: '',
                                                    email: '',
                                                    cpwd: '',
                                                    phone: '',
                                                    namealert: '',
                                                    pwdalert: ''
                                                })}>Already a user? Login</a>
                                                <div style={{ display: this.state.login_state == true ? '' : 'none' }} className='div_gap'> | </div>
                                                <a style={{ display: this.state.login_state == true ? '' : 'none' }} onClick={() => (this.setState({
                                                    name: '',
                                                    pwd: '',
                                                    email: '',
                                                    cpwd: '',
                                                    phone: '',
                                                }), this.props.history.push('/password'))}>Forgot Password</a>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <Footer />
            </div>
        )


    }

}

export default Login;